import { Link, Routes, Route, Navigate } from "react-router-dom"
import WebsiteScraping from "./WebsiteScraping"
import GTMManagement from "./GTMManagement"
import WebsiteDetails from "./WebsiteDetails"
import GTMDetails from "./GTMDetails"
import AnalyticsDetails from "./AnalyticsDetails"

export default function WebsiteAudit() {
  return (
    <div className="page-container page-container--wide">
      <h2>Website Audit</h2>
      <nav className="sub-nav">
        <Link to="/website-audit/scraping">Scraping</Link>
        <Link to="/website-audit/gtm-management">GTM Management</Link>
      </nav>
      <Routes>
        <Route path="/" element={<Navigate to="scraping" replace />} />
        <Route path="scraping" element={<WebsiteScraping />} />
        <Route path="gtm-management" element={<GTMManagement />} />
        <Route path="details/:websiteId" element={<WebsiteDetails />} />
        <Route path="gtm-details/:websiteId" element={<GTMDetails />} />
        <Route path="gtm-details/:websiteId/:gtmId" element={<GTMDetails />} />
        <Route path="analytics-details/:websiteId" element={<AnalyticsDetails />} />
        <Route path="analytics-details/:websiteId/:gaId" element={<AnalyticsDetails />} />
      </Routes>
    </div>
  )
}
